import EmojiPicker from "emoji-picker-react";
import { useState } from "react";

const ReactionBar = ({ rowData, type, messageId, onReact, handleCopy, handleReply, handleForward, handleDeleteSingleMesg }) => {
    const commonReactions = [
        { emoji: '👍', label: 'Thumbs Up' },
        { emoji: '😂', label: 'Laugh' },
        { emoji: '❤️', label: 'Heart' },
        { emoji: '😮', label: 'Surprise' },
        { emoji: '😢', label: 'Sad' }
    ];
    const [showFullPicker, setShowFullPicker] = useState(false);
    const [showOptions, setShowOptions] = useState(false);

    return (
        <div className="reaction-bar">
            {/* Quick reaction emojis */}
            <div className="quick-reactions">
                {commonReactions.map((reaction) => (
                    <span
                        key={reaction.emoji}
                        className="reaction-btn cursor-pointer"
                        onClick={() => onReact(messageId, reaction.emoji)}
                        aria-label={reaction.label}
                    >
                        {reaction.emoji}
                    </span>
                ))}

                {/* More options button */}
                {/* <button
                    className="more-reactions-btn"
                    onClick={() => setShowFullPicker(!showFullPicker)}
                    aria-label="More reactions"
                >
                    +
                </button> */}
                <div className="d-flex align-items-center gap-6">
                    <span className="spreater d-flex" onClick={(e) => { e.stopPropagation(); handleCopy(rowData.message) }}>
                        <i class="icon-new-copy fs-16"></i>
                    </span>
                    <i class="icon-new-reply fs-16" onClick={(e) => { e.stopPropagation(); handleReply(rowData, type) }}></i>
                    <i class="icon-new-forword fs-16" onClick={() => handleForward(rowData)}></i>
                    <i class="bi bi-three-dots-vertical fw-900 fs-16 ar-light-color" onClick={() => setShowOptions(!showOptions)}></i>
                </div>
            </div>
            {showOptions && (
                <div className="ar-edit-and-delete-options d-flex flex-column gap-5">
                    <div className="ar-border ps-1-5 cursor-pointer user-select-none w-100">
                        <p className="text fs-11">Edit</p>
                    </div>
                    <div className="ps-1-5 cursor-pointer user-select-none w-100" onClick={() => handleDeleteSingleMesg(rowData)}>
                            <p className="text fs-11">Delete</p>
                    </div>
                </div>
            )}

            {
                showFullPicker && (
                    <div className="full-emoji-picker">
                        <EmojiPicker
                            onEmojiClick={(emojiData) => {
                                onReact(messageId, emojiData.emoji);
                                setShowFullPicker(false);
                            }}
                            width={300}
                            height={350}
                        />
                    </div>
                )
            }
        </div >
    );
};

export default ReactionBar;